import { useCustomTranslation } from "../../../helpers/translateHelpers";
import Icon from "../../icon/Icon";
import LoadingIndicator from "../../loading/LoadingIndicator";

interface UploadFileItemProps {
  item: FileItem;
  onRemove: () => void;
}

export interface FileItem {
  uid: string;
  name: string;
  status: UploadStatus;
  percent: number;
  attachmentId?: string;
}

export type UploadStatus = "uploading" | "success" | "fail";

const UploadFileItem = ({ item, onRemove }: UploadFileItemProps) => {
  const { tInput, tError } = useCustomTranslation();

  return (
    <div className="border-gray-accent mb-4 flex flex-1 flex-row items-center rounded-[10px] border-1 px-4 py-3 text-[14px]/[21px]">
      <Icon name="paperclip" size="small" />
      <span className="ml-2 flex-1">{item.name}</span>
      {item.status === "uploading" && (
        <div className="mx-2 flex flex-row items-center">
          <LoadingIndicator />
          <span className="ml-2">{tInput("attchment_uploading")}</span>
        </div>
      )}
      {item.status === "fail" && (
        <span className="text-error mr-2">
          {tError("attachment_upload_failed")}
        </span>
      )}
      {(item.status === "success" || item.status === "fail") && (
        <Icon
          name="close"
          onClick={onRemove}
          className="cursor-pointer"
          size="small"
        />
      )}
    </div>
  );
};

export default UploadFileItem;
